export const Footer = () => {
  return (
    <footer className="container">
      <hr />
      <p style={{ textAlign: 'center' }}>
        <small>
          Dispo<em>flare</em> ·{' '}
          <a href="https://github.com/LeoColomb/dispoflare">GitHub</a> ·{' '}
          Licensed under{' '}
          <a
            href="https://github.com/LeoColomb/dispoflare/blob/main/LICENSE"
            className="secondary"
          >
            MIT License
          </a>
        </small>
      </p>
    </footer>
  )
}
